import { ListPage } from "@services/common/types";
import {
  MeetingInstance,
  MeetingInstanceFilters,
  ScheduledMeeting,
} from "@services/meetings/types";
import API from "@services/root/rootApi";
import {
  Alarms,
  AlarmFilters,
  MonitoringGraphData,
  MetaData,
  MonitoringPause,
} from "./types";

export const getAlarms = async (filters?: AlarmFilters): Promise<Alarms> => {
  let to = new Date();
  let from = new Date();
  from.setMinutes(to.getMinutes() - 1);
  const response = await API.post<Alarms>(
    `/symphony-api/monitoring/alarm`,
    filters,
    {
      params: {
        from: from.getTime(),
        to: to.getTime(),
      },
    }
  );

  return response.data;
};

export const getGraph = async (
  deviceId?: string,
  from?: number,
  to?: number,
  graphType?: string,
  custom?: boolean
): Promise<MonitoringGraphData[]> => {
  const params: any = {
    deviceId: deviceId,
    from: from,
    to: to,
    custom: custom,
  };
  if (deviceId) {
    const response = await API.get<MonitoringGraphData[]>(
      `/symphony-api/monitoring/graph?graphType=${graphType}`,
      {
        params,
      }
    );
    return response.data;
  }
  return [];
};

export const getDeviceGraphMetaData = async (
  deviceId: string
): Promise<MetaData[]> => {
  const response = await API.get<MetaData[]>(
    `/symphony-api/monitoring/graph/metadata`,
    {
      params: { deviceId },
    }
  );

  return response.data;
};

export const getMonitoringMeetings = async (
  startDate: number,
  endDate: number,
  roomid: string
): Promise<ListPage<MeetingInstance>> => {
  const response = await API.post<ListPage<MeetingInstance>>(
    `/symphony-api/monitoring/instance`,
    { "participants.room.id": roomid },
    {
      params: {
        startDate: startDate,
        endDate: endDate,
      },
    }
  );

  return response.data;
};

export const getScheduledMeeting = async (
  id: number
): Promise<ScheduledMeeting> =>
  (await API.get(`/symphony-api/meeting/schedule/${id}`)).data;

export const putScheduledMeeting = async (
  id: number,
  meeting: ScheduledMeeting
) => await API.put(`/symphony-api/meeting/schedule/${id}`, meeting);

export const postMonitoringMeeting = async (
  id: number,
  params: ScheduledMeeting
): Promise<MeetingInstance> => {
  const response = await API.post<ScheduledMeeting>(
    `/symphony-api/meeting/instance/${id}`,
    params
  );
  return response.data;
};

export const pauseMonitoring = async (
  id: string,
  component: "room" | "device",
  data: MonitoringPause
): Promise<void> => {
  await API.post<any>(
    `/symphony-api/monitoring/${component}/${id}/pause`,
    data
  );
};

export const resumeMonitoring = async (
  id: string,
  component: "room" | "device"
): Promise<void> => {
  await API.post<any>(`/symphony-api/monitoring/${component}/${id}/resume`);
};

export const getMonitoringMeetingId = async (
  meetingId: MeetingInstance["id"],
  startDate: Number
): Promise<MeetingInstance> => {
  const response = await API.get<MeetingInstance>(
    `/symphony-api/meeting/instance/meetingid/${meetingId}?start=${startDate}`
  );

  return response.data;
};
